

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="RevolverMatrix" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { RevolverMatrixProps } from './RevolverMatrix.ts';
import RevolverMatrix from './RevolverMatrix.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-revolver-matrix';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<RevolverMatrixProps>();
const changableProps = useChangableProps(componentName, props);

</script>


